import { timeFormat } from "d3";

const formatDate = timeFormat("%d.%m, %H:%M");

export default formatDate;
